<div #chartWrapper class="chart-wrapper"></div>
